import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';

// 🔥 Points examinés - Code du travail
const POINTS_CODE_TRAVAIL = [
  {
    code: "R4215-3",
    points: [
      "Protection contre les chocs électriques :\nContacts directs (état de l'isolant des canalisations, des boîtes de connexion et des luminaires)",
      "Contacts indirects (mises à la terre, protections différentielles adaptées au risque)",
      "Protection des circuits terminaux par DDR haute sensibilité"
    ]
  },
  { code: "R4215-5", points: ["Protection contre les risques de brûlures et d'incendie"] },
  { code: "R4215-6", points: ["Choix des appareils de coupure et de protection contre les surintensités (type, calibre, pouvoir de coupure)"] },
  { code: "R4215-7", points: ["Dispositif de sectionnement"] },
  { code: "R4215-8", points: ["Coupures d'urgence"] },
  { code: "R4215-9", points: ["Mise en œuvre des canalisations fixes et des canalisations souples"] },
  { code: "R4215-10", points: ["Identification des circuits et des appareillages, repérage des canalisations et des conducteurs"] },
  { code: "R4215-11", points: ["Choix et mise en œuvre des matériels et des canalisations vis-à-vis des conditions d'environnement particulières - IP des matériels"] },
  { code: "R4215-12", points: ["Conformité des installations dans les locaux à risque d'incendie"] },
  { code: "R4216-12", points: ["Conformité des installations dans les locaux à risque d'explosion"] },
  { code: "R4215-12 Arrêté du 20/12/2011", points: ["Appareils amovibles BT et TBT (conformité, état et raccordement)"] },
  { code: "R4215-17 Arrêté du 14/12/2011", points: ["Installations d'éclairage de sécurité"] },
  { code: "R4215-3 R4215-8", points: ["Tubes lumineux et enseignes HT"] },
  { code: "R4215-8", points: ["Vérification des dispositifs de coupure d'urgence"] },
  { code: "R4215-16", points: ["Conformité aux normes des matériels électriques ayant une fonction de sécurité"] },
  { code: "", points: ["Dispositions spécifiques à certains établissements ou à certaines installations"] }
];

// 🔥 Points examinés - Mesurages et essais
const POINTS_MESURAGES = [
  { id: "resistance_isolement", label: "Résistance d'isolement des circuits et matériels", checked: true },
  { 
    id: "resistance_prise_terre", 
    label: "Résistance de prise de terre",
    checked: true,
    hasSubOptions: true,
    subOptions: [
      { id: "methode_terres_aux", label: "Méthode des terres auxiliaires" },
      { id: "methode_boucle", label: "Méthode de la résistance de boucle « neutre-terre »" }
    ]
  },
  { id: "resistance_continuite", label: "Résistance de la continuité des conducteurs de protection", checked: true },
  { id: "essai_ddr", label: "Essais des dispositifs différentiels résiduels (DDR)", checked: true },
  { id: "essai_eclairage", label: "Essai de l'éclairage de sécurité", checked: false },
  { id: "essai_coupure_urgence", label: "Essai des dispositifs de coupure d'urgence", checked: true }
];

// Styles inline pour éviter les problèmes CSS
const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  saveBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer'
  },
  tempBadge: {
    margin: '16px 20px',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
    border: '2px solid #f59e0b',
    borderRadius: '12px',
    color: '#92400e',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '14px'
  },
  priseInfo: {
    margin: '0 20px 16px',
    padding: '16px',
    background: 'linear-gradient(135deg, #d1fae5, #a7f3d0)',
    borderRadius: '12px',
    border: '2px solid #10b981'
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px'
  },
  infoLabel: {
    color: '#065f46',
    fontWeight: '500',
    fontSize: '13px'
  },
  infoValue: {
    color: '#047857',
    fontWeight: '700',
    fontSize: '14px'
  },
  tabs: {
    display: 'flex',
    gap: '8px',
    padding: '0 20px',
    marginBottom: '16px'
  },
  tab: {
    flex: 1,
    padding: '12px 16px',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '600',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: '#e2e8f0',
    color: '#64748b'
  },
  tabActive: {
    background: 'linear-gradient(135deg, #3b82f6, #2563eb)',
    color: 'white',
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
  },
  sectionContent: {
    padding: '0 20px'
  },
  codeItem: {
    background: 'white',
    borderRadius: '12px',
    marginBottom: '12px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  codeHeader: {
    background: 'linear-gradient(135deg, #475569, #334155)',
    color: 'white',
    padding: '10px 16px',
    fontWeight: '600',
    fontSize: '13px'
  },
  pointRow: {
    padding: '12px 16px',
    borderBottom: '1px solid #f1f5f9'
  },
  pointText: {
    fontSize: '13px',
    color: '#334155',
    lineHeight: '1.5',
    marginBottom: '10px',
    whiteSpace: 'pre-line'
  },
  statusButtons: {
    display: 'flex',
    gap: '8px'
  },
  statusBtn: {
    flex: 1,
    padding: '8px 12px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontWeight: '700',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: 'white',
    color: '#64748b'
  },
  statusBtnC: {
    borderColor: '#bbf7d0',
    color: '#16a34a'
  },
  statusBtnCActive: {
    background: '#16a34a',
    color: 'white',
    borderColor: '#16a34a'
  },
  statusBtnNC: {
    borderColor: '#fecaca',
    color: '#dc2626'
  },
  statusBtnNCActive: {
    background: '#dc2626',
    color: 'white',
    borderColor: '#dc2626'
  },
  statusBtnSO: {
    borderColor: '#e2e8f0',
    color: '#64748b'
  },
  statusBtnSOActive: {
    background: '#64748b',
    color: 'white',
    borderColor: '#64748b'
  },
  mesurageItem: {
    background: 'white',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    cursor: 'pointer'
  },
  checkbox: {
    width: '20px',
    height: '20px',
    marginTop: '2px',
    accentColor: '#3b82f6'
  },
  subOptions: {
    margin: '12px 0 12px 30px',
    padding: '12px',
    background: '#f8fafc',
    borderRadius: '8px'
  },
  radioLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '8px',
    cursor: 'pointer'
  },
  radio: {
    width: '18px',
    height: '18px',
    accentColor: '#3b82f6'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f8fafc'
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #e2e8f0',
    borderTopColor: '#f59e0b',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite'
  }
};

function Etape14Temporaire({ mission, onBack, onSave }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeSection, setActiveSection] = useState('code_travail');

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_14_points_examines_temporaires');
      
      if (savedData && savedData.points_code_travail && savedData.points_mesurages) {
        setData(savedData);
      } else {
        const initialData = {
          points_code_travail: POINTS_CODE_TRAVAIL.map(item => ({
            code: item.code,
            points: item.points.map(p => ({
              texte: p,
              conforme: true,
              non_conforme: false,
              sans_objet: false,
              observations: []
            }))
          })),
          points_mesurages: POINTS_MESURAGES.map(item => ({
            id: item.id,
            label: item.label,
            checked: item.checked,
            conforme: true,
            non_conforme: false,
            sans_objet: false,
            observations: [],
            subOptions: item.hasSubOptions ? item.subOptions.map(sub => ({
              id: sub.id,
              label: sub.label,
              checked: sub.id === 'methode_terres_aux'
            })) : []
          })),
          valeurs_prise_terre: []
        };
        setData(initialData);
      }
      
      const etape5Data = await inspectionStorage.getStep(mission.id, 'etape_5_prises_terre');
      if (etape5Data && etape5Data.mesures && etape5Data.mesures.length > 0) {
        const valeurs = etape5Data.mesures
          .map((mesure) => {
            const value = mesure.valeur_mesuree ?? mesure.valeur_ohms ?? mesure.valeur;
            if (value === undefined || value === null || value === '') return null;
            const localisation = mesure.localisation ? `${mesure.localisation} : ` : '';
            const methode = mesure.methode_mesure ? ` (${mesure.methode_mesure})` : '';
            return `${localisation}${value} Ω${methode}`;
          })
          .filter(Boolean);
        setData(prev => ({
          ...prev,
          valeurs_prise_terre: valeurs
        }));
      }
      
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (category, itemIndex, pointIndex, newStatus) => {
    setData(prev => {
      const updated = { ...prev };
      
      if (category === 'code_travail') {
        const point = updated.points_code_travail[itemIndex].points[pointIndex];
        point.conforme = newStatus === 'C';
        point.non_conforme = newStatus === 'NC';
        point.sans_objet = newStatus === 'SO';
      } else if (category === 'mesurages') {
        const point = updated.points_mesurages[itemIndex];
        point.conforme = newStatus === 'C';
        point.non_conforme = newStatus === 'NC';
        point.sans_objet = newStatus === 'SO';
      }
      
      return updated;
    });
  };

  const handleMesurageCheckChange = (index) => {
    setData(prev => {
      const updated = { ...prev };
      updated.points_mesurages[index].checked = !updated.points_mesurages[index].checked;
      return updated;
    });
  };

  const handleSubOptionChange = (mesurageIndex, subIndex) => {
    setData(prev => {
      const updated = { ...prev };
      const mesurage = updated.points_mesurages[mesurageIndex];
      mesurage.subOptions.forEach((opt, idx) => {
        opt.checked = idx === subIndex;
      });
      return updated;
    });
  };

  const getCurrentStatus = (point) => {
    if (point.conforme) return 'C';
    if (point.non_conforme) return 'NC';
    if (point.sans_objet) return 'SO';
    return 'C';
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_14_points_examines_temporaires', data);
      console.log('✅ Étape 14 Temporaire sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={{...styles.spinner, animation: 'spin 1s linear infinite'}}></div>
        <p style={{marginTop: '16px', color: '#64748b', fontWeight: '500'}}>Chargement...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Points examinés</h1>
        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      {/* Badge temporaire */}
      <div style={styles.tempBadge}>
        ⚡ Installation Temporaire (R4226-21)
      </div>

      {/* Valeurs prises de terre */}
      {data.valeurs_prise_terre && data.valeurs_prise_terre.length > 0 && (
        <div style={styles.priseInfo}>
          <div style={styles.infoRow}>
            <span style={styles.infoLabel}>Résistance prise de terre:</span>
          </div>
          {data.valeurs_prise_terre.map((valeur, index) => (
            <div key={`pt-${index}`} style={{...styles.infoRow, marginBottom: index === data.valeurs_prise_terre.length - 1 ? 0 : 8}}>
              <span style={styles.infoValue}>{valeur}</span>
            </div>
          ))}
        </div>
      )}

      {/* Tabs */}
      <div style={styles.tabs}>
        <button 
          style={{...styles.tab, ...(activeSection === 'code_travail' ? styles.tabActive : {})}}
          onClick={() => setActiveSection('code_travail')}
        >
          📜 Code du travail
        </button>
        <button 
          style={{...styles.tab, ...(activeSection === 'mesurages' ? styles.tabActive : {})}}
          onClick={() => setActiveSection('mesurages')}
        >
          📊 Mesurages
        </button>
      </div>

      {/* Section Code du travail */}
      {activeSection === 'code_travail' && (
        <div style={styles.sectionContent}>
          {data.points_code_travail.map((item, itemIndex) => (
            <div key={itemIndex} style={styles.codeItem}>
              <div style={styles.codeHeader}>{item.code || 'Général'}</div>
              {item.points.map((point, pointIndex) => {
                const status = getCurrentStatus(point);
                return (
                  <div key={pointIndex} style={styles.pointRow}>
                    <div style={styles.pointText}>{point.texte}</div>
                    <div style={styles.statusButtons}>
                      <button 
                        style={{...styles.statusBtn, ...styles.statusBtnC, ...(status === 'C' ? styles.statusBtnCActive : {})}}
                        onClick={() => handleStatusChange('code_travail', itemIndex, pointIndex, 'C')}
                      >
                        C
                      </button>
                      <button 
                        style={{...styles.statusBtn, ...styles.statusBtnNC, ...(status === 'NC' ? styles.statusBtnNCActive : {})}}
                        onClick={() => handleStatusChange('code_travail', itemIndex, pointIndex, 'NC')}
                      >
                        NC
                      </button>
                      <button 
                        style={{...styles.statusBtn, ...styles.statusBtnSO, ...(status === 'SO' ? styles.statusBtnSOActive : {})}}
                        onClick={() => handleStatusChange('code_travail', itemIndex, pointIndex, 'SO')}
                      >
                        SO
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}

      {/* Section Mesurages */}
      {activeSection === 'mesurages' && (
        <div style={styles.sectionContent}>
          {data.points_mesurages.map((item, index) => {
            const status = getCurrentStatus(item);
            return (
              <div key={index} style={styles.mesurageItem}>
                <div style={{marginBottom: '12px'}}>
                  <label style={styles.checkboxLabel}>
                    <input 
                      type="checkbox" 
                      checked={item.checked}
                      onChange={() => handleMesurageCheckChange(index)}
                      style={styles.checkbox}
                    />
                    <span style={{fontSize: '14px', color: '#334155', fontWeight: '500', lineHeight: '1.4'}}>{item.label}</span>
                  </label>
                </div>
                
                {item.subOptions && item.subOptions.length > 0 && (
                  <div style={styles.subOptions}>
                    {item.subOptions.map((sub, subIndex) => (
                      <label key={subIndex} style={styles.radioLabel}>
                        <input 
                          type="radio" 
                          name={`sub_${index}`}
                          checked={sub.checked}
                          onChange={() => handleSubOptionChange(index, subIndex)}
                          style={styles.radio}
                        />
                        <span style={{fontSize: '13px', color: '#475569'}}>{sub.label}</span>
                      </label>
                    ))}
                  </div>
                )}
                
                <div style={styles.statusButtons}>
                  <button 
                    style={{...styles.statusBtn, ...styles.statusBtnC, ...(status === 'C' ? styles.statusBtnCActive : {})}}
                    onClick={() => handleStatusChange('mesurages', index, null, 'C')}
                  >
                    C
                  </button>
                  <button 
                    style={{...styles.statusBtn, ...styles.statusBtnNC, ...(status === 'NC' ? styles.statusBtnNCActive : {})}}
                    onClick={() => handleStatusChange('mesurages', index, null, 'NC')}
                  >
                    NC
                  </button>
                  <button 
                    style={{...styles.statusBtn, ...styles.statusBtnSO, ...(status === 'SO' ? styles.statusBtnSOActive : {})}}
                    onClick={() => handleStatusChange('mesurages', index, null, 'SO')}
                  >
                    SO
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Bouton sauvegarder */}
      <div style={styles.saveSection}>
        <button 
          style={{...styles.saveButton, ...(saving ? {opacity: 0.6, cursor: 'not-allowed'} : {})}} 
          onClick={handleSave} 
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape14Temporaire;